import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { Button, Icon } from 'components';
import { useAuth } from 'contexts/AuthContext';
import cn from 'classnames';

interface NewPatientStepProps {
	title: string;
	className?: string;
	prevStep?: string;
	nextStep?: string;
	children: React.ReactElement;
	handleOnClickNext?: Function | null;
	isValid?: boolean;
}

export const NewPatientStep = ({
	title,
	className,
	prevStep,
	nextStep,
	children,
	handleOnClickNext,
	isValid = true,
}: NewPatientStepProps) => {
	const { t } = useTranslation();
	const [loading, setLoading] = useState(false);
	const navigate = useNavigate();
	const { user } = useAuth();
	const { isAdmin } = user;
	const { patientId } = useParams();

	const onNextClick = async () => {
		if (handleOnClickNext) {
			try {
				setLoading(true);
				(!isAdmin || (isAdmin && nextStep === '/final')) &&
					(await handleOnClickNext());
				nextStep && isValid && navigate(`..${nextStep}`, { replace: true });
			} catch (error) {
				throw error;
			} finally {
				setLoading(false);
			}
		}
	};

	return (
		<div
			className={cn('relative flex flex-col h-full  pb-10 justify-between', className)}
		>
			<div>
				<h1 className='text-orange text-2xl mb-6 mt-16'>{title}</h1>
				{children}
			</div>
			<div className='fixed bottom-14 self-end flex justify-end'>
				{prevStep && (
					<Button
						type='link'
						className='mr-6 flex items-center'
						to={`..${prevStep}`}
					>
						<Icon
							name='BackArrow'
							className='mr-2'
						/>
						<p>{t('goBack')}</p>
					</Button>
				)}
				<Button
					type='div'
					handleClick={onNextClick}
					background
					loading={loading}
					className='flex items-center'
				>
					<p>
						{!isAdmin || nextStep === '/final' ? t('saveChanges') : t('next')}
					</p>
					<Icon
						name='NextArrow'
						className='ml-2'
					/>
				</Button>
			</div>
		</div>
	);
};
